import http from "../http-common";

export const updateIdentity = (patient_id, data) => {
    return http.post(`/core/collector/update/${patient_id}/ident/`, data)
}